import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container'

import logo from '../../images/Weblogo.png'
import headerimg from '../../images/mooncropedimg.png'


const useStyles = makeStyles((theme) => ({
  logo: {
      maxWidth: 130
  },
  dashboardBtn: {
    maxWidth: 200
  },
  root: {
    justifyContent: 'space-between',
    alignItems: 'center',
    
  },
  links: {
    color: '#fff',
    padding: '0px 12px',
    fontWeight: 700,
    textTransform: 'uppercase',
    '&:hover': {
      color: "#f4f4f4",
      TextDecoder: 'none'
   },
  }
}));

const Menu = (props) => {
  const classes = useStyles();
  
  return (
    <div className={classes.root + " py-4 px-3 d-sm-flex"}>
      <img src={headerimg} className="img-fluid mr-2" style={{maxWidth: '93px',
    zIndex: '0',
    position: 'absolute',
    // left: '92%',
    right:'-8px',
    top: '0%',}} />
      <div className="text-center" >
        <Typography variant="h6" noWrap className="pl-2 text-light">
          <Link to="/" className={classes.links}>
            <img src={logo} alt="logo" className={classes.logo + " img-fluid"} />
          </Link>
        </Typography>
      </div>
      <div className="text-center text-sm-right mt-4 mt-sm-0" style={{zIndex: '1'}}>
        <Link to="/" className={classes.links}>
          Home
        </Link>
        <Link to="/locker" className={classes.links}>
          Locker
        </Link>
        <Link to="/dashboard" className={classes.links}>
          Dashboard
        </Link>

      </div>
    </div>
  );
}

export default Menu;
